let organizationId: number | undefined
const organizations = new Map<string, number | undefined>()

export function setRequestOrganization(id: number | undefined) {
  organizationId = id
}
export function getRequestOrganization() {
  return organizationId
}
export function selectedOrganization(userId: string): number | undefined {
  if (organizations.has(userId)) return organizations.get(userId)
  try {
    const value = sessionStorage.getItem(`refined.organization.${userId}`)
    return value && /^\d+$/.test(value) ? Number(value) : undefined
  } catch {
    return undefined
  }
}
export function selectOrganization(userId: string, id: number) {
  organizations.set(userId, id)
  try {
    sessionStorage.setItem(`refined.organization.${userId}`, String(id))
  } catch {
    // Keep this document's requests pinned when browser storage is unavailable.
  }
}

const invitationKey = "refined.learner-invitation"
let invitation: string | null | undefined
let invitationStorageFailed = false
export function invitationStorageUnavailable() {
  return invitationStorageFailed
}
export function captureInvitation(): string | null {
  const params = new URLSearchParams(window.location.hash.slice(1))
  const token = params.get("token")
  if (token) {
    invitation = token
    try {
      sessionStorage.setItem(invitationKey, token)
      invitationStorageFailed = false
    } catch {
      invitationStorageFailed = true
    }
    // Always redact before telemetry/Clerk, even when persistence fails.
    window.history.replaceState(
      window.history.state,
      "",
      window.location.pathname + window.location.search,
    )
  }
  if (invitation !== undefined) return invitation
  try {
    return sessionStorage.getItem(invitationKey)
  } catch {
    invitationStorageFailed = true
    return null
  }
}
export function hasInvitation() {
  return !!captureInvitation()
}
export function clearInvitation() {
  invitation = null
  invitationStorageFailed = false
  try {
    sessionStorage.removeItem(invitationKey)
  } catch {
    // The in-memory tombstone prevents reuse in this document.
  }
}
export function clearAccountSession(userId?: string | null) {
  if (userId) {
    organizations.set(userId, undefined)
    try {
      sessionStorage.removeItem(`refined.organization.${userId}`)
    } catch {
      // Sign-out and account switching must still complete.
    }
  }
  clearInvitation()
}
